import "core-js/modules/es6.function.name";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '900px'
    },
    height: {
      type: String,
      default: '450px'
    },
    top: {
      type: String,
      default: '-65px'
    },
    left: {
      type: String,
      default: '-22px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {// setTimeout(() => {
    // 	this.initBarChart()
    // }, 1000)
    // this.$nextTick(() => {})
  },
  methods: {
    initBarChart: function initBarChart(data) {
      //	趋势图
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      var mainData = data; // mainData.push({
      // 	name: '同比',
      // 	value: 342305,
      // 	prevalue: 382305,
      // 	hismax: 455898,
      // 	unit: 'm'
      // });
      // mainData.push({
      // 	name: '本月降雨量',
      // 	value: 1332042,
      // 	prevalue: 1222305,
      // 	hismax: 1896900,
      // 	unit: 'm/Min'
      // });
      // mainData.push({
      // 	name: '环比',
      // 	value: 305652,
      // 	prevalue: 323305,
      // 	hismax: 446783,
      // 	unit: 'm'
      // });

      function createSeries(mainData) {
        var result = [];
        var colors = ['#aaaaff', '#2ec7c9', '#5ab1ef'];
        var insideLabel = {
          normal: {
            position: 'center',
            formatter: function formatter(params) {
              if (params.name == "其他") return "";
              return '\n\n\n\n\n' + params.value + '\n' + params.data.unit + '\n\n\n\n' + params.name + (params.name != '同比' && params.name != '环比' ? '' : '                 ');
            },
            textStyle: {
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontSize: 12
            }
          }
        };
        var outsideLabel = {
          normal: {
            show: false
          }
        };
        var itemOthers = {
          normal: {
            color: '#ccc'
          }
        };

        for (var i = 0; i < mainData.length; i++) {
          var increase = mainData[i].value > mainData[i].prevalue;
          result.push({
            type: 'pie',
            center: [i * 20 + 10 + '%', '30%'],
            radius: ['17%', '20%'],
            label: insideLabel,
            itemStyle: {
              color: colors[i]
            },
            data: [{
              name: '其他',
              value: mainData[i].hismax - mainData[i].value,
              itemStyle: itemOthers,
              unit: mainData[i].unit
            }, {
              name: mainData[i].name,
              value: mainData[i].value,
              prevalue: mainData[i].prevalue,
              unit: mainData[i].unit
            }],
            markPoint: {
              data: [{
                symbol: i == 1 ? 'none' : 'arrow',
                symbolSize: 15,
                symbolRotate: increase ? 0 : 180,
                itemStyle: {
                  normal: {
                    color: 'green'
                  }
                },
                name: mainData[i].name,
                value: (mainData[i].prevalue == 0 ? 0 : ((mainData[i].value - mainData[i].prevalue) * 100 / mainData[i].prevalue).toFixed(2)) + '%',
                x: i == 0 ? myChart.getWidth() * 0.18 : myChart.getWidth() * 0.55,
                y: increase ? 188 : 203,
                label: {
                  normal: {
                    show: i == 1 ? false : true,
                    position: 'left',
                    formatter: function formatter(params) {
                      return params.value;
                    },
                    textStyle: {
                      color: 'green'
                    }
                  }
                }
              }]
            }
          });
        }

        return result;
      }

      var option = {
        tooltip: {
          show: true,
          formatter: function formatter(params) {
            if (params.name == "其他") return "";
            return params.marker + params.name + ':' + params.value + params.data.unit;
          }
        },
        toolbox: {
          show: false,
          feature: {
            dataView: {
              show: true,
              readOnly: true
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        series: createSeries(mainData)
      };
      myChart.setOption(option, true);
      window.addEventListener('resize', function () {
        myChart.resize();
        console.log('宽：', myChart.getWidth());
        option = {
          tooltip: {
            show: true,
            formatter: function formatter(params) {
              if (params.name == "其他") return "";
              return params.marker + params.name + ':' + params.value + params.data.unit;
            }
          },
          toolbox: {
            show: false,
            feature: {
              dataView: {
                show: true,
                readOnly: true
              },
              restore: {
                show: true
              },
              saveAsImage: {
                show: true
              }
            }
          },
          series: createSeries(mainData)
        };
        myChart.setOption(option, true);
      });
    }
  }
};